import {
  MainLayout as CoreMainLayout,
  IMainLayoutProps,
} from '@myhrbox/myhrbox-frontend-core';
import ROUTES from 'constants/routes';
import withErrorBoundary from 'hocs/withErrorBoundary';
import useNavigateWithReplace from 'hooks/useNavigateReplace';

const RegisterLayout = (props: IMainLayoutProps) => {
  const { navigate } = useNavigateWithReplace();
  const { children, onLogoClick, ...rest } = props;

  return (
    <CoreMainLayout
      onLogoClick={() => navigate(ROUTES.ASSESSMENT)}
      HeaderComponent={undefined}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </CoreMainLayout>
  );
};

export default withErrorBoundary(RegisterLayout);
